<template>
    <div>
        <div v-show="!childShow">
            <table-title>租借人在租数</table-title>
            <!-- 查询 -->
            <div class="serach">
                <Form ref="formValidate" :label-width="125" inline>
                <div>
                    <FormItem label="租借人">
                        <payee-select class="shrug" roleType="LEASEE" v-model="queryParams.leaseeId"></payee-select>
                    </FormItem>
                    <FormItem label="标的物小类">
                        <target-type-select v-model="queryParams.targetType" />
                    </FormItem>
                    <Button type="primary" style="margin-left:20px" @click="getQuery">查询</Button>
                </div>
                </Form>
            </div>
            <!-- 列表 -->
            <div class="table">
                <data-grid ref="dg" :columns="cols" :queryParams="queryParams" paramsName="params" :pageNum="1" :pageSize="20" :queryUrl="queryUrl">
                    <template #default="{ columns, data }">
                        <Table :columns="columns" :data="data" border stripe size="small">
                            <template slot-scope="{ row }" slot="action">
                                <Button type="success" size="small" style="margin-left: 5px" @click="toDetail(row)">明细</Button>
                            </template>
                        </Table>
                    </template>
                </data-grid>
            </div>
        </div>

        <div v-show="childShow">
            <data-grid ref="detailRef" :columns="detailCols" :queryParams="queryDetailParams" :autoLoad="false" paramsName="params" :pageNum="1" :pageSize="20" :queryUrl="queryDetailUrl"></data-grid>
            <div style="text-align:center">
                <Button type="success" size="small" style="margin-left: 5px" @click="back">返回</Button>
            </div>
        </div>
    </div>
</template>
<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'

import dataGrid from '@/components/datagrid.vue';
import payeeSelect from '@/components/select/payee-select.vue';
import targetTypeSelect from '@/components/select/targetTypeSelect.vue';
export default {
    components: {
        tableTitle,
        dataGrid,
        payeeSelect,
        targetTypeSelect,
    },
    data(){
        return {
            queryUrl : 'http://CORE-CONTRACT/messageService/queryService/queryAssetHoldListByPageParam',
            queryDetailUrl : 'http://CORE-CONTRACT/messageService/queryService/queryAssetHoldDetailsByPageParam',
            cols: [
                {title: '租借人', key: 'leaseeId', dict: ['bizObjects', 'member',true] },
                {title: '标的物小类', key: 'targetType', dict: ['target', 'type',true] },
                // {title: '计租数', key: 'billingAmount' },
                {title: '在租数', key: 'rentingAmount' },
                {title: '操作', slot: 'action' },
            ],
            detailCols: [
                {title: '合约号', key: 'id' },
                {title: '标的物小类', key: 'targetType', dict: ['target', 'type',true] },
                {title: '初始数量', key: 'amount' },
                {title: '在租数', key: 'rentingAmount' },
                {title: '开始计租日', key: 'startBillingDate' },
                {title: '租期', key: 'rentTerm' },
                {title: '最小停租时间', key: 'leaseeMinBillingStopDate' },
            ],
            queryParams: {
                leaseeId: "",
                targetType: "",
            },
            queryDetailParams: {
                leaseeId: "",
                targetType: "",
            },
            childShow : false
        }
    },
    mounted(){

    },
    methods : {
        getQuery(){
            this.$refs['dg'].loadFirstPage()
        },
        toDetail(row){
            this.queryDetailParams.leaseeId = row.leaseeId;
            this.queryDetailParams.targetType = row.targetType;
            this.$refs['detailRef'].loadFirstPage()
            this.childShow = true;
        },
        back(){
            this.childShow = false;
        }
    }
}
</script>